// ISDP CUSTOM: Gate the entire authenticated app. Only Dräger devs and admins may
// enter the internal developer hub. This runs after Backstage sign-in, so the user's
// identity (and therefore role) is always available here.
//
// Where a public/partner user goes depends on the release scope
// (devhub.features.partnerPortal, see isdp-common/release.ts):
//   - portal shipped  → the external Partner Portal, rendered in-app (ExternalWorld)
//   - portal hidden   → <NoInternalAccess/> below, because there is nowhere else to be
import { useApi, identityApiRef } from '@backstage/core-plugin-api';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { authMessages } from '../../i18n/auth';
import { clearSignedIn } from './portalSession';
import './RoleGuard.css';

export function RoleSplash({ message }: { message: string }) {
  return (
    <div className="devhub-roleguard-splash">
      <odx-logo size="lg" aria-label="Dräger" />
      <div className="devhub-roleguard-spinner" aria-hidden="true" />
      <p>{message}</p>
    </div>
  );
}

/**
 * Terminal state for a signed-in user who may not enter the internal hub, in a
 * release where the external portal is not shipped. It is a dead end by design —
 * the only action is to sign out — so no internal route is ever reachable from here.
 */
export function NoInternalAccess() {
  const identityApi = useApi(identityApiRef);
  const { t } = useTranslationRef(authMessages);

  return (
    <div className="devhub-roleguard-splash devhub-roleguard-splash--message">
      <odx-logo size="lg" aria-label="Dräger" />
      <h1>{t('noAccess.title')}</h1>
      <p>{t('noAccess.desc')}</p>
      <odx-button
        variant="primary"
        onClick={() => {
          clearSignedIn();
          identityApi.signOut();
        }}
      >
        {t('noAccess.signOut')}
      </odx-button>
    </div>
  );
}
